import { render, staticRenderFns } from "./user.vue?vue&type=template&id=a1e4a8c2"
import script from "./user.vue?vue&type=script&lang=ts"
export * from "./user.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./user.vue?vue&type=style&index=0&id=a1e4a8c2&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports